<template>
    <div class="status-dot" :class="readPriorita()" >
        <div></div>
    </div>
</template>
<script>

export default{
    name: 'PriorityDot',
    props:[
        'priorita'
    ],
    methods:{
        readPriorita(){
            return `priority-${this.priorita?.toLowerCase() ?? 'unknown'}`;
        }
    }
}
</script>